import PlainShell from "../../../layouts/PlainShell.vue";

import {
  StepOne,
  StepTwo,
  StepThree,
  StepFour,
  StepFive,
  StepSix,
  StepSeven,
} from "@/modules/registration-questionnaire/section";

export default [
  {
    path: "/",
    name: "",
    component: PlainShell,
    children: [
      {
        path: "/registration-questionnaire/1",
        name: "RegistrationQuestionnaireOne",
        component: StepOne,
        title: "Registration Questionnaire Page 1",
        meta: {
          currentPage: 1,
        },
      },
      {
        path: "/registration-questionnaire/2",
        name: "RegistrationQuestionnaireTwo",
        component: StepTwo,
        title: "Registration Questionnaire Page 2",
        meta: {
          currentPage: 2,
        },
      },
      {
        path: "/registration-questionnaire/3",
        name: "RegistrationQuestionnaireThree",
        component: StepThree,
        title: "Registration Questionnaire Page 3",
        meta: {
          currentPage: 3,
        },
      },
      {
        path: "/registration-questionnaire/4",
        name: "RegistrationQuestionnaireFour",
        component: StepFour,
        title: "Registration Questionnaire Page 4",
        meta: {
          currentPage: 4,
        },
      },
      {
        path: "/registration-questionnaire/5",
        name: "RegistrationQuestionnaireFive",
        component: StepFive,
        title: "Registration Questionnaire Page 5",
        meta: {
          currentPage: 5,
        },
      },
      {
        path: "/registration-questionnaire/6",
        name: "RegistrationQuestionnaireSix",
        component: StepSix,
        title: "Registration Questionnaire Page 6",
        meta: {
          currentPage: 6,
        },
      },,
      {
        path: "/registration-questionnaire/7",
        name: "RegistrationQuestionnaireSeven",
        component: StepSeven,
        title: "Registration Questionnaire Page 7",
        meta: {
          currentPage: 7,
        },
      },
    ],
  },
];
